import React from "react";

const NotFound = () => {
  return (
    <div className="not-found-main">
      <div className="not-found-container">
        <h1 className="not-found-title">404 | Not Found</h1>
      </div>
    </div>
  );
};

export default NotFound;
